import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Typography,
  Paper,
  Divider
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

/**
 * Composant réutilisable pour gérer les clés API
 * @param {Object} props - Propriétés du composant
 * @param {string} props.serviceName - Nom du service (ex: "AssemblyAI", "OpenAI")
 * @param {string} props.apiKey - Clé API
 * @param {string} [props.organizationId] - ID d'organisation (optionnel)
 * @param {Function} props.onSave - Fonction appelée lors de la sauvegarde
 * @param {boolean} props.saving - Indique si une sauvegarde est en cours
 * @param {boolean} [props.hasOrganizationId=false] - Indique si le service utilise un ID d'organisation
 * @returns {JSX.Element}
 */
const ApiKeySettings = ({
  serviceName,
  apiKey,
  organizationId = '',
  onSave,
  saving,
  hasOrganizationId = false
}) => {
  // États locaux
  const [localApiKey, setLocalApiKey] = useState(apiKey || '');
  const [localOrgId, setLocalOrgId] = useState(organizationId || '');
  const [showApiKey, setShowApiKey] = useState(false);
  
  // Gestionnaire pour la sauvegarde
  const handleSave = () => {
    const data = {
      apiKey: localApiKey
    };
    
    if (hasOrganizationId) {
      data.organizationId = localOrgId;
    }
    
    onSave(data);
  };
  
  return (
    <Box>
      <TextField
        label={`Clé API ${serviceName}`}
        value={localApiKey}
        onChange={(e) => setLocalApiKey(e.target.value)}
        fullWidth
        margin="normal"
        type={showApiKey ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={() => setShowApiKey(!showApiKey)}>
                {showApiKey ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          )
        }}
        helperText={`Clé API ${serviceName} pour accéder au service`}
      />
      
      {hasOrganizationId && (
        <TextField
          label="ID d'organisation (optionnel)"
          value={localOrgId}
          onChange={(e) => setLocalOrgId(e.target.value)}
          fullWidth
          margin="normal"
          helperText={`ID d'organisation ${serviceName} (si applicable)`}
        />
      )}
      
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
        <Button 
          variant="contained" 
          startIcon={<SaveIcon />}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Enregistrement en cours...' : 'Enregistrer la clé API'}
        </Button>
      </Box>
    </Box>
  );
};

export default ApiKeySettings; 